<template>
  <div
    v-if="kapal.transmitter"
    class="flex flex-col px-3 py-8 w-full h-full">
    <div class="flex flex-row mb-3 w-full">
      <div :class="`Flags Flag-${kapal.bendera_kapal}`"></div>
      <h1 class="flex flex-col flex-1 px-2 py-1">
        <b class="text-sm text-white">{{ kapal.nama_kapal }}</b>
        <span class="text-xs text-gray-100">{{ kapal.no_sipi }}</span>
      </h1>
    </div>
    <div class="flex flex-col mb-3 w-full">
      <p class="text-xs text-gray-100">{{ kapal.tanda_selar }}</p>
      <p class="text-sm text-blue-300 font-bold">{{ kapal.transmitter }}</p>
    </div>
    <hr class="mb-3 mr-5" />
    <div v-if="onoff" class="Scroll pr-3 w-full h-full">
      <div class="mb-1">
        <p class="flex flex-row justify-center items-center px-2 py-1 gap-1 text-sm text-stone-900 bg-gray-300">
          <span class="flex-grow">Periode ON/OFF</span>
          <button
            @click="closeOnOff()"
            class="px-1 py-1 w-16 h-6 bg-blue-500 text-white text-xs rounded-md"
            type="button">Detail</button>
        </p>
      </div>
      <p class="flex gap-1 my-1 justify-content items-center">
        <b class="material-icons text-xs text-red-500">emergency</b>
        <span class="text-xs text-white">durasi merupakan rentang waktu ke ping selanjutnya</span>
      </p>
      <table class="table-auto w-full mb-3">
        <colgroup>
          <!-- <col style="width: 10%;" /> -->
          <col style="width: 35%;" />
          <col style="width: 65%;" />
        </colgroup>
        <thead>
          <tr>
            <th class="font-normal h-10 border border-gray-400 border-r-0 px-3 py-3 text-xs text-white text-left font-bold">Durasi</th>
            <th class="font-normal h-10 border border-gray-400 border-l-0 px-3 py-3 text-xs text-white text-right font-bold">Tanggal</th>
          </tr>
        </thead>
        <tbody class="border border-gray-400">
          <tr
            v-for="(item, index) in historyOnoff"
            :key="index"
            class="hover:bg-gray-300 cursor-pointer">
            <td class="text-xs text-left px-3 py-1 text-white" v-html="item.properties.onoff"></td>
            <td
              @click="setHistoryIndex(index, item.properties)"
              class="text-xs text-right px-3 py-1 text-white">{{ utcFormatTimes(item.properties.PING_TIME) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="Scroll pr-3 w-full h-full">
      <div class="mb-1">
        <p class="flex flex-row justify-center items-center px-2 py-1 gap-1 text-sm text-stone-900 bg-gray-300">
          <span class="flex-grow">Kapal</span>
          <button
            v-if="$route.path == '/salmontrack/history'"
            @click="openOnOff()"
            class="px-1 py-1 w-16 h-6 bg-blue-500 text-white text-xs rounded-md"
            type="button">ON/OFF</button>
          <button
            @click="track(kapal.transmitter, kapal.ping_time)"
            class="px-1 py-1 w-16 h-6 bg-gray-500 text-white text-xs rounded-md"
            type="button">Track</button>
        </p>
        <div class="py-1">
          <table class="TableDetailKapal text-xs text-white">
            <tbody>
              <tr>
                <td>Nomor Buku</td>
                <td>:</td>
                <td>{{ kapal.nomor_buku_kapal }}</td>
              </tr>
              <tr>
                <td>Skema</td>
                <td>:</td>
                <td>{{ kapal.skema_permohonan }}</td>
              </tr>
              <tr>
                <td>Jenis Kapal</td>
                <td>:</td>
                <td>{{ kapal.jenis_kapal }}</td>
              </tr>
              <tr>
                <td>Kecepatan</td>
                <td>:</td>
                <td>{{ kapal.speed / 10 }} knot</td>
              </tr>
              <tr>
                <td>Provider</td>
                <td>:</td>
                <td>{{ kapal.provider }}</td>
              </tr>
              <tr>
                <td>Last Ping</td>
                <td>:</td>
                <td>{{ utcFormatTimes(kapal.ping_time) }}</td>
              </tr>
              <tr>
                <td>Last Position</td>
                <td>:</td>
                <td>{{ kapal.lat }}, {{ kapal.lon }}</td>
              </tr>
              <tr>
                <td>GT</td>
                <td>:</td>
                <td>{{ kapal.ukuran_gt }}</td>
              </tr>
              <tr>
                <td>Pangkalan</td>
                <td>:</td>
                <td>{{ kapal.nama_pelabuhan_pangkalan || '-' }}</td>
              </tr>
              <tr>
                <td>Domisili</td>
                <td>:</td>
                <td>{{ kapal.pelabuhan_domisili || '-' }}</td>
              </tr>
              <tr>
                <td>Muat Singgah</td>
                <td>:</td>
                <td>{{ kapal.pelabuhan_muat_singgah || '-' }}</td>
              </tr>
              <tr>
                <td>Pelabuhan Tujuan</td>
                <td>:</td>
                <td>{{ kapal.pelabuhan_negara_tujuan || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="mb-1">
        <p class="px-2 py-1 text-sm text-stone-900 bg-gray-300">Alat Tangkap</p>
        <p class="py-1 text-xs text-white">{{ kapal.jenis_alat_tangkap }}</p>
      </div>
      <div class="mb-1">
        <p class="px-2 py-1 text-sm text-stone-900 bg-gray-300">Pemilik</p>
        <table class="TableDetailKapal text-xs text-white">
          <tbody>
            <tr>
              <td>Perusahaan</td>
              <td>:</td>
              <td>{{ kapal.nama_perusahaan }}</td>
            </tr>
            <tr>
              <td>No. SIUP</td>
              <td>:</td>
              <td>{{ kapal.no_siup }}</td>
            </tr>
            <tr>
              <td>Penangung Jawab</td>
              <td>:</td>
              <td>{{ kapal.penangung_jawab }}</td>
            </tr>
            <tr>
              <td>NEGARA</td>
              <td>:</td>
              <td>{{ kapal.negara }}</td>
            </tr>
            <tr>
              <td>Bendera Kapal</td>
              <td>:</td>
              <td>{{ kapal.bendera_kapal }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="flex flex-col mb-1">
        <p class="px-2 py-1 text-sm text-stone-900 bg-gray-300">SIPI</p>
        <div class="py-1">
          <table class="TableDetailKapal text-xs text-white">
            <tbody>
              <tr>
                <td>Nomor</td>
                <td>:</td>
                <td>{{ kapal.no_sipi }}</td>
              </tr>
              <tr>
                <td>Tgl. Tanda Tangan</td>
                <td>:</td>
                <td>{{ utcFormatDate(kapal.tanggal_tanda_tangan) }}</td>
              </tr>
              <tr>
                <td>Tgl. Berlaku</td>
                <td>:</td>
                <td>{{ utcFormatDate(kapal.tanggal_awal_sipi) }}</td>
              </tr>
              <tr>
                <td>Tgl. Berakhir</td>
                <td>:</td>
                <td>{{ utcFormatDate(kapal.tanggal_akhir_sipi) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="flex flex-col mb-1">
        <p class="px-2 py-1 text-sm text-stone-900 bg-gray-300">SKAT</p>
        <div class="py-1">
          <table class="TableDetailKapal text-xs text-white">
            <tbody>
              <tr>
                <td>Nomor</td>
                <td>:</td>
                <td>{{ kapal.nomor_skat || '-' }}</td>
              </tr>
              <tr>
                <td>Tgl. Terbit</td>
                <td>:</td>
                <td>{{ kapal.tanggal_terbit_skat || '-' }}</td>
              </tr>
              <tr>
                <td>Tgl. Berakhir</td>
                <td>:</td>
                <td>{{ kapal.tanggal_berlaku_skat || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="mb-1">
        <p class="px-2 py-1 text-sm text-stone-900 bg-gray-300">DPI</p>
        <p class="py-1 text-xs text-white">{{ kapal.nama_dpi }}</p>
      </div>
      <div class="mb-1">
        <p class="px-2 py-1 text-sm text-stone-900 bg-gray-300">WPP</p>
        <p class="py-1 text-xs text-white">{{ kapal.nama_wpp }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import libs from '../libs'

export default {
  name: 'SidebarDetailKapal',
  data: () => ({
    onoff: false
  }),
  computed: {
    ...mapGetters([
      'kapal',
      'history',
      'setHistoryIndex'
    ]),
    historyOnoff: function () {
      const histories = {}

      for (var historyIndex in this.history.features) {
        const history = this.history.features[historyIndex]
        const gaptime = this.onoffDuration(history, historyIndex)

        if (gaptime.type !== 'detik' && gaptime.type !== 'menit' && gaptime.type !== '') {
          history.properties.onoff = gaptime.elapsed + ' ' + gaptime.type

          if (gaptime.type === 'jam' && gaptime.elapsed >= 24) {
            histories[historyIndex] = history
          } else {
            histories[historyIndex] = history
          }
        }
      }

      return histories
    }
  },
  methods: {
    ...mapActions(['toActiveMenu']),
    ...mapMutations([
      'setHistories',
      'setHistory'
    ]),
    timeElapsed: (d) => libs.timeElapsed(d),
    utcFormatDate: (d) => libs.localTime(d, 'date', false, false, false),
    utcFormatTimes: (d) => libs.localTime(d, 'full', false, false, false),
    onoffDuration: function (item, index) {
      index = parseInt(index)

      let timeType = ''
      let elapsed = 0

      if (this.history.features[index + 1]) {
        elapsed = new Date(this.history.features[index + 1].properties.PING_TIME).getTime() - (new Date(item.properties.PING_TIME)).getTime()

        if (elapsed > 86400000) {
          timeType = 'hari'
          elapsed = Math.round(elapsed / 86400000)
        } else if (elapsed > 3600000) {
          timeType = 'jam'
          elapsed = Math.round(elapsed / 3600000)
        } else if (elapsed > 60000) {
          timeType = 'menit'
          elapsed = Math.round(elapsed / 60000)
        } else {
          timeType = 'detik'
        }
      }

      return {
        type: timeType,
        elapsed: elapsed
      }
    },
    track: function (transmitter, pingtime) {
      pingtime = libs.utcFormat(pingtime, 'object')

      const startTime = pingtime.datetime
      const endTime = (new Date(pingtime.default.getTime() - (1000 * 60 * 60 * 24 * 30)))
                        .toLocaleString('en-CA', { hourCycle: 'h23'})

      this.setHistories({
        transmitter: transmitter,
        start: endTime,
        end: startTime
      })
      this.setHistory({
        transmitter: transmitter,
        start: endTime,
        end: startTime
      })
      this.toActiveMenu({
        name: 'Tracking',
        force: true
      })
    },
    openOnOff: function () {
      this.onoff = true
    },
    closeOnOff: function () {
      this.onoff = false
    }
  }
}
</script>

<style scoped>
.TableDetailKapal {
  width: 100%;
}
.TableDetailKapal tr td {
  vertical-align: top;
}
.TableDetailKapal tr td:nth-child(1) {
  width: 40%;
}
.TableDetailKapal tr td:nth-child(2) {
  width: 2.5%;
}
.TableDetailKapal tr td:nth-child(3) {
  width: 57.5%;
}
</style>
